import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *  Create an entityReducer with a custom name against a shared endpoint. This avoids state
 *  collisions with search, paging, and filtering.
 */
import { constantsRegistry } from '../../constants/tableConstantsFactory';
import entityReducerFactory from './entityReducerFactory';
const customLookupReducerFactory = (entity, indexQueryFragment) => {
  const constants = constantsRegistry(entity);
  const entityReducer = entityReducerFactory(entity);
  const indexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), indexQueryFragment);
  const initState = _objectSpread(_objectSpread({}, entityReducer.initState), {}, {
    indexQuery,
    initialIndexQuery: indexQuery
  });

  /**
   * Override entityReducerFactor.filterClear to account for custom indexQueryFragments
   */
  const filterClear = state => _objectSpread(_objectSpread({}, state), {}, {
    indexQuery: JSON.parse(JSON.stringify(indexQuery)),
    initialIndexQuery: JSON.parse(JSON.stringify(indexQuery))
  });

  // used to clean up dirty state made by serverIndex
  const indexCancel = state => _objectSpread(_objectSpread({}, state), {}, {
    list: [],
    indexQuery
  });
  const reducers = _objectSpread(_objectSpread({}, entityReducer.reducers), {}, {
    [constants.FILTER_CLEAR]: filterClear,
    [constants.INDEX_CANCEL]: indexCancel
  });

  // note that the returned object is intended for composition and client code will need to call
  // `applyReducers(reducers, state)` to get an expected redux reducer
  return {
    reducers,
    initState
  };
};
export default customLookupReducerFactory;